export { default } from './RecentlyReturnedUtilityBar';



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedUtilityBar/index.js